// The i18n keys the Connected logins page renders its two dynamic vocabularies
// through. Closed records over `lib/identities.ts`' enumerations, so a provider
// or a link refusal added there without a label is a type error here, and
// `i18n.test.ts` pins every key against the catalog.

import type { IdentityProvider, LinkErrorCode } from './identities';

export const PROVIDER_LABEL_KEY: Readonly<Record<IdentityProvider, string>> = {
  github: 'logins.provider_github',
  oidc: 'logins.provider_oidc',
  saml: 'logins.provider_saml',
  platform_oidc: 'logins.provider_platform_oidc',
};

export const LINK_ERROR_KEY: Readonly<Record<LinkErrorCode | 'unknown', string>> = {
  owned_elsewhere: 'logins.link_error_owned_elsewhere',
  not_member: 'logins.link_error_not_member',
  idp_unreachable: 'logins.link_error_idp_unreachable',
  idp_misconfigured: 'logins.link_error_idp_misconfigured',
  unauthorized: 'logins.link_error_unauthorized',
  sso_not_enabled: 'logins.link_error_sso_not_enabled',
  saml_link_unsupported: 'logins.link_error_saml_link_unsupported',
  link_failed: 'logins.link_error_link_failed',
  unknown: 'logins.link_error_unknown',
};
